import { SortableItem } from '@box-types';
import dayjs from 'dayjs';
import { orderBy } from 'lodash-es';
import { isCurrentTimeInTimeRange } from './date.utils';

function getSortableItemPosition<T extends SortableItem>(item: T): number {
  if (!item.sortingPerDay?.length) return item.position;
  const currentDay = dayjs().locale('en').format('dddd');
  const currentSorting = item.sortingPerDay.find((sorting) => sorting.day === currentDay);
  if (!currentSorting) return item.position;
  const currentTimeRange = currentSorting.timeRanges.find((timeRange) => isCurrentTimeInTimeRange(timeRange));
  if (!currentTimeRange) return item.position;
  return currentTimeRange.position;
}

function sortSortableItems<T extends SortableItem & { type?: string }>(items: T[]): T[] {
  if (!items?.length) return [];

  const navigatorItem = items.find((item) => item.type === 'navigator');
  const otherItems = items.filter((item) => item.type !== 'navigator');

  const sortedOthers = orderBy(otherItems, getSortableItemPosition, 'asc');

  const result = navigatorItem ? [navigatorItem, ...sortedOthers] : sortedOthers;

  return result as T[]; // ✅ tell TS it's the same type
}

export { getSortableItemPosition, sortSortableItems };
